import React, { useState } from "react";
import s from './index.module.css';
import { List } from 'antd';
import data from '../../dada.json';
import { Link } from 'react-router-dom';

export default function Home({ searchKeyword }) {  // 接收searchKeyword作为props
  const { projects } = data;

  // 使用一个对象来管理所有筛选条件
  const [filters, setFilters] = useState({
    type: "不限",
    category: "不限",
    price: "不限",
    transfer: "不限",
    source: "不限",
    maturity: "不限",
  });

  // 统一处理筛选条件的变化
  const handleFilterChange = (filterType, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [filterType]: value
    }));
  };

  // 根据筛选条件和搜索关键字过滤项目
  const filteredProjects = projects.filter(project => {
    // 先进行筛选条件的过滤
    const isMatchType = filters.type === "不限" || project.project === filters.type;
    const isMatchCategory = filters.category === "不限" || project.projectClassification === filters.category;
    const isMatchPrice = filters.price === "不限" || project.price === filters.price;
    const isMatchTransfer = filters.transfer === "不限" || project.transferMethod === filters.transfer;
    const isMatchSource = filters.source === "不限" || project.projectSource === filters.source;
    const isMatchMaturity = filters.maturity === "不限" || project.maturity === filters.maturity;

    // 然后再根据搜索关键字进行模糊匹配
    const isMatchSearch = project.name.toLowerCase().includes(searchKeyword.toLowerCase());

    return isMatchType && isMatchCategory && isMatchPrice && isMatchTransfer && isMatchSource && isMatchMaturity && isMatchSearch;
  });

  // 渲染筛选项
  const renderFilter = (filterType, options) => {
    return (
      <div className={s.row}>
        <div className={s.title}>{options.title}：</div>
        <div className={s.content}>
          <ul>
            {options.values.map(value => (
              <li key={value}>
                <a
                  href="/"
                  className={filters[filterType] === value ? s.active : ""}
                  onClick={(e) => { e.preventDefault(); handleFilterChange(filterType, value); }}
                >
                  {value}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={s.home}>
        <div className={s.condition}>
          {renderFilter('type', {
            title: '项目类型',
            values: ['不限', '专利项目', '实用技术', '科研成果']
          })}
          {renderFilter('category', {
            title: '项目分类',
            values: ['不限', '节能环保', '机器制造', '医疗卫生']
          })}
          {renderFilter('price', {
            title: '交易价格',
            values: ['不限', '面议']
          })}
          {renderFilter('transfer', {
            title: '转让方式',
            values: ['不限', '面议', '技术转让', '普通许可', '技术入股', '技术指导', '合作办厂', '合作开发', '联合推广', '委托加工', '专利转让', '交钥匙工程']
          })}
          {renderFilter('source', {
            title: '项目来源',
            values: ['不限', '北京市', '上海市', '天津市']
          })}
          {renderFilter('maturity', {
            title: '项目成熟度',
            values: ['不限', '正在研发', '已有样品', '通过小试', '通过中试', '通过量产', '已经应用', '通过临床试验', '经过测试', '已有样机', '已获药品批号', '已获临床批件']
          })}
        </div>

        <div className={s.list}>
          <div className={s.list_left}>
            <div className={s.list_title}>
              <div>项目列表</div>
            </div>
            <div className={s.list_content}>
              <List
                pagination={{ position: "bottom", align: "center" }}
                dataSource={filteredProjects}
                renderItem={project => (
                  <List.Item key={project.number}>
                    <div className={s.item}>
                      {/* 项目图片 */}
                      <div className={s.item_img}>
                        <Link to={`/detail/${project.number}`}>
                          <img
                            src={`/assets/images/example/${project.image}`}
                            alt={project.name}
                          />
                        </Link>
                      </div>
                      {/* 左侧信息 */}
                      <div className={s.item_left}>
                        <div>
                          <Link to={`/detail/${project.number}`} className={s.item_left_title}>
                            {project.name}
                          </Link>
                        </div>
                        <div className={s.item_left_info}>
                          项目简介：{project.introduction}
                        </div>
                        <div className={s.item_left_info}>
                          项目成熟度：{project.maturity}
                        </div>
                        <div className={s.item_left_info}>
                          项目分类：{project.projectClassification}
                        </div>
                      </div>

                      {/* 右侧价格 */}
                      <div className={s.item_right}>
                        价格：
                        <span className={s.price}>
                          {project.price || "面议"}
                        </span>
                      </div>
                    </div>
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
